import { createAction } from '@reduxjs/toolkit';

import { api, handleApiErrors } from 'lib/src/utils/api';
import { clearJwtToken } from 'lib/src/utils/jwt';
import { AppDispatch } from 'src/redux/store';

// Login
export const postLoginRequest = createAction('postLoginRequest');
export const postLoginSuccess = createAction('postLoginSuccess');
export const postLoginFailure = createAction<string>('postLoginFailure');

export const postLogin =
    (postBody: LoginRequestModel) =>
    async (dispatch: AppDispatch): Promise<void> => {
        dispatch(postLoginRequest());

        try {
            const { data }: LoginResponseModel = await api.post('admin/auth/login', {
                ...postBody,
                isAdmin: true,
            });

            clearJwtToken();
            localStorage.setItem('mfaToken', data.mfaToken);

            dispatch(postLoginSuccess());
        } catch (e) {
            handleApiErrors(dispatch, postLoginFailure, e);
        }
    };

interface LoginRequestModel {
    email: string;
    password: string;
}

interface LoginResponseModel {
    data: { token: null; hasMfa: boolean; mfaToken: string };
}
